// AuthContext.js
import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(!!sessionStorage.getItem("customer"));
    const [customer, setCustomer] = useState(sessionStorage.getItem("customer") ? JSON.parse(sessionStorage.getItem("customer")) : null);

    const login = (customerData) => {
        sessionStorage.setItem("customer", JSON.stringify(customerData));
        setCustomer(customerData);
        setIsLoggedIn(true);
    };

    const logout = () => {
        sessionStorage.removeItem("customer");
        setCustomer(null);
        setIsLoggedIn(false);
    };

    useEffect(() => {
        const syncAuth = () => {
            const storedCustomer = sessionStorage.getItem("customer");
            if (storedCustomer) {
                setCustomer(JSON.parse(storedCustomer));
                setIsLoggedIn(true);
            } else {
                setCustomer(null);
                setIsLoggedIn(false);
            }
        };
        window.addEventListener("storage", syncAuth);
        return () => window.removeEventListener("storage", syncAuth);
    }, []);

    return (
        <AuthContext.Provider value={{ isLoggedIn, customer, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};